import React, { useState } from 'react';
import PropTypes, { func } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import {
  IconReviewUser,
  Modal,
  PrimaryButton,
  SecondaryButton,
} from '../../components';

import css from './CancelBookingModal.module.css';

const CancelBookingModal = props => {
  const {
    className = null,
    rootClassName = null,
    id,
    intl,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    onCancelSale,
    cancelInProgress,
    cancellationPolicy = 'flexible',
    cancelSaleError = null,
  } = props;

  const effectiveCancellationPolicy =
    cancellationPolicy === 'strict' ? 'strict' : 'flexible';

  const classes = classNames(rootClassName || css.root, className);
  const closeButtonMessage = intl.formatMessage({ id: 'CancelBookingModal.close' });

  const [currentStep, setCurrentStep] = useState(0);

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={closeButtonMessage}
    >
      <IconReviewUser className={css.modalIcon} />
      <p className={css.modalTitle}>
        <FormattedMessage id="CancelBookingModal.title" />
      </p>

      {currentStep === 0 && (
        <>
          <p className={css.modalMessage}>
            <FormattedMessage id="CancelBookingModal.beforeCancellation" />
          </p>
          <p className={css.modalTitle}>
            <FormattedMessage id="CancelBookingModal.refundRules" />
          </p>

          <p className={css.modalSmallTitle}>
            <FormattedMessage
              id={`CancellationPolicy.${effectiveCancellationPolicy}.label`}
            />
          </p>
          <p className={css.modalMessage}>
            <FormattedMessage
              id={`CancellationPolicy.${effectiveCancellationPolicy}.description`}
            />
          </p>

          <div className={css.buttonsContainer}>
            <SecondaryButton
              className={css.submitButton}
              onClick={e => {
                e.preventDefault();
                onCloseModal();
              }}
            >
              <FormattedMessage id="CancelBookingModal.close" />
            </SecondaryButton>

            <PrimaryButton
              className={css.submitButton}
              inProgress={cancelInProgress}
              disabled={cancelInProgress}
              onClick={e => {
                e.preventDefault();
                onCancelSale().then(r => {
                  setCurrentStep(1);
                });
              }}
            >
              <FormattedMessage id="CancelBookingModal.cancel" />
            </PrimaryButton>
          </div>
        </>
      )}

      {currentStep === 1 && (
        <>
          <p className={css.modalMessage}>
            <FormattedMessage id="CancelBookingModal.afterCancellation" />
          </p>

          <SecondaryButton
            className={css.submitButton}
            onClick={e => {
              e.preventDefault();
              onCloseModal();
            }}
          >
            <FormattedMessage id="CancelBookingModal.close" />
          </SecondaryButton>
        </>
      )}
    </Modal>
  );
};

const { bool, string } = PropTypes;

CancelBookingModal.propTypes = {
  className: string,
  rootClassName: string,
  intl: intlShape.isRequired,
  isOpen: bool.isRequired,
  onCloseModal: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onCancelSale: func.isRequired,
  cancelSaleError: propTypes.error,
  cancelInProgress: bool.isRequired,
  cancellationPolicy: string,
};

export default injectIntl(CancelBookingModal);
